export const PROBLEM_CLASSES = {
    FAQ: "FAQ",
    ROADBLOCK: "ROADBLOCK",
    PROCESS_FAIL: "PROCESS_FAIL",
};

// can only relate solution class to this and back forth
